import { userLookup } from "./user-lookup";

(($) => {
  $(() => {
    const $shopButtonsList = $('.shop-buttons__list');
    if ($shopButtonsList.length) {
      const user = userLookup()
      const $shopButtons = $shopButtonsList.find('.btn,.link--wave')
      if ( user && user.province ) {
        $shopButtons.each((index, element) => {
          const $element = $(element);
          if ( $element.data(`url-${ user.province }`) ) {
            $element.attr('href', $element.data(`url-${ user.province }`))
            $element.closest('.shop-buttons__list').removeClass('d-none')
          }
        })
      }
      if ( Shopify.designMode ) {
        console.log('design!')
        $shopButtons.each((index, element) => {
          const $element = $(element);
          if ( $element[0].innerHTML ) {
            $element.closest('.shop-buttons__list').removeClass('d-none')
          }
        })
      }
    }
  });
})(jQuery);

